import { ca } from '@cian/analytics';

export const trackBookingCallbackClick = () => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'newbuilding_finder',
    name: 'oldevent',
    label: 'callback_from_bookedflat',
    useLastProducts: true,
  });
};
